import hatsApi from '@/services/hatsApi'

export default {
  getAll () {
    return hatsApi().get('/system/reservation-status')
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/ReservationStatus.js